import { Link, withRouter } from "react-router-dom";
import { useState } from "react";

const Navbar = ({ history }) => {
  const sesionActiva = localStorage.getItem("sesionActiva");
  const nombreUsuario = localStorage.getItem("nombre");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("sesionActiva");
    localStorage.removeItem("nombre");
    localStorage.removeItem("tipo");
    history.push("/login");
  };

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-success">
      <div className="container-fluid">
        <div className="d-flex align-items-center">
          <Link
            className="nav-item nav-link active text-white fw-bold"
            to="/listar"
          >
            <img src="/logo-blanco.png" alt="" height="35" className="ms-2" />
          </Link>
        </div>

        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleMenu}
          aria-controls="navbarNav"
          aria-expanded={menuOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}
          id="navbarNav"
        >
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link
                className="nav-link text-white nav-icon"
                to="/listar"
                onClick={() => setMenuOpen(false)}
              >
                <i className="fa-solid fa-house"></i>{" "}
                <span className="ms-1">INICIO</span>
              </Link>
            </li>
          </ul>

          {sesionActiva && (
            <div className="nav-item dropdown">
              <div
                className="nav-link dropdown-toggle text-white"
                onClick={toggleDropdown}
                role="button"
                aria-haspopup="true"
                aria-expanded={dropdownOpen}
              >
                <i className="fas fa-user me-2"></i>
                <span className="text-uppercase">DR. {nombreUsuario}</span>
              </div>
              {dropdownOpen && (
                <div className="dropdown-menu dropdown-menu-end show">
                  <button onClick={handleLogout} className="dropdown-item">
                    <i className="fas fa-sign-out-alt"></i> Cerrar Sesión
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default withRouter(Navbar);
